/**
 * External destinations that appear on more than one surface.
 *
 * "Talk to sales" was previously pointing at four different places depending
 * on where you clicked it — the in-app /demo/book page in the header, and
 * three separate Calendly links elsewhere — so the same label produced a
 * different booking experience per page. One constant, one destination.
 *
 * Every booking surface on the site now resolves through TALK_TO_SALES_URL,
 * including the embedded widget on /demo/book, so changing the calendar is a
 * one-line change rather than a hunt.
 */
export const TALK_TO_SALES_URL = 'https://calendly.com/tonyennis/see-giga-in-action-clone';

/**
 * The address to reach a human without booking a slot.
 *
 * A calendar is a real barrier for anyone who has a question rather than an
 * evaluation: it asks for a name, a company, and thirty minutes of a future
 * day before they can say a sentence. Every booking CTA is now paired with
 * this so there is always a lower-commitment way through.
 */
export const SUPPORT_EMAIL = 'support@getgiga.com';
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
